export function sendEvent ({ category, action, label }) {
  if (window.ga) {
    window.ga('send', 'event', category, action, label)
  } else {
    if (typeof console !== 'undefined') {
      console.log('ga.sendEvent', category, action, label)
    }
  }
}



// WEBPACK FOOTER //
// ./src/lib/googleAnalytics.js